var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Type } from './Type';
import { Bitmap } from './Bitmap';
var Packet = /** @class */ (function (_super) {
    __extends(Packet, _super);
    function Packet(schema) {
        var _this = _super.call(this) || this;
        _this._schema = schema;
        _this._bitmap = new Bitmap();
        return _this;
    }
    Packet.prototype.encodeBuffer = function (value, buffer) {
        var _this = this;
        var propsBitmap = [];
        var values = [];
        Object.keys(this._schema).forEach(function (prop) {
            if (value[prop] === null || value[prop] === undefined) {
                // @ts-ignore
                propsBitmap.push(false);
            }
            else {
                // @ts-ignore
                propsBitmap.push(true);
                // @ts-ignore
                values.push({
                    type: _this._schema[prop],
                    value: value[prop],
                });
            }
        }, this);
        // @ts-ignore
        this._bitmap.encodeBuffer(propsBitmap, buffer);
        for (var i = 0; i < values.length; i++) {
            // @ts-ignore
            values[i].type.encodeBuffer(values[i].value, buffer);
        }
    };
    Packet.prototype.decodeBuffer = function (buffer) {
        var _this = this;
        var propsBitmap = this._bitmap.decodeBuffer(buffer);
        var value = {};
        Object.keys(this._schema).forEach(function (prop, index) {
            if (propsBitmap[index]) {
                // @ts-ignore
                value[prop] = _this._schema[prop].decodeBuffer(buffer);
            }
        }, this);
        return value;
    };
    return Packet;
}(Type));
export { Packet };
